<template>
  <div class="page-main flex-page">
    <!--START: Header-->
    <PageHeader
      :content="headerContent"
      :disableButton="showOptions.disableButton || showOptions.saveInProgress"
      :showHeaderShadow="showOptions.headerShadow"
      :showButton="false"
    ></PageHeader>
    <!--END: Header-->

    <!--Wrapper-->
    <div
      v-if="!gettingAgents"
      ref="mainContent"
      class="main-content"
      @scroll="contentScroll"
    >
      <!--Agents Table-->
      <AgentsTable
        v-if="showOptions.agentsTable"
        :agents="agents"
        @updateAgent="updateAgent"
      ></AgentsTable>

      <!--Zero State -->
      <ZeroState
        v-else
        class="zero-state"
        :imageURL="zeroStateData.imageURL"
        :title="zeroStateData.title"
        :message="zeroStateData.message"
        :buttonTitle="zeroStateData.buttonTitle"
        @eventHandler="redirectSubscriptions"
      ></ZeroState>
    </div>

    <!--Pre Loader-->
    <PreLoader v-else :show="true" class="main-content"></PreLoader>

    <!--START: Loader-->
    <LineLoader :show="showOptions.lineLoader"></LineLoader>
    <!--END: Loader-->
  </div>
</template>
                
<script>
// Libraries
import _ from "lodash";

// Components
import PageHeader from "@/components/dashboard/PageHeader";
import LineLoader from "@/components/loaders/LineLoader";
import AgentsTable from "@/components/apps/Translations/AgentsTable";
import PreLoader from "@/components/loaders/PreLoader";
import ZeroState from "@/components/misc/ZeroState";

// Defaults
import { APP_NAMES, LANGUAGES } from "@/mixins/Variables";

// Services
import { TranslationsAppService } from "@/services";
const { CompanyService, UserService } = TranslationsAppService;

export default {
  name: "Agents",
  data() {
    return {
      lodash: _,
      showOptions: {
        headerShadow: false,
        lineLoader: false,
        agentsTable: true,
      },
      headerContent: {
        title: "Agents",
        description: "Manage your agent language settings",
      },
      languageField: {
        type: "dropdown",
        placeholder: "Select language",
        required: false,
        hasError: false,
        isSmallField: true,
        fields: LANGUAGES,
        value: "",
      },
      gettingAgents: true,
      agents: [],
      zeroStateData: {
        imageURL: "services.jpg",
        title: "No licenses assigned",
        message: "Assign licenses to your agents to give them access",
        buttonTitle: "Assign Licenses",
      },
    };
  },
  props: {},
  watch: {},
  components: {
    PageHeader,
    LineLoader,
    AgentsTable,
    PreLoader,
    ZeroState,
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    selectedApp() {
      return this.$store.getters.selectedApp;
    },
    subscription() {
      return this.selectedApp.subscription;
    },
  },
  async created() {
    await this.initApp();
    await this.getAgents();
  },
  methods: {
    // Initialise the app
    async initApp() {
      if (_.isEmpty(this.selectedApp)) {
        const data = { companyId: this.company._id };
        const response = await CompanyService.GetCompany(data);

        this.$store.commit("updateSelectedApp", {
          appName: APP_NAMES.translations,
          ...response.data,
        });
      }
    },

    // Get agents
    async getAgents() {
      this.gettingAgents = true;

      if (
        this.subscription.status === "active" &&
        this.subscription?.licenses?.users?.length === 0
      ) {
        this.showOptions.agentsTable = false;
      } else {
        this.showOptions.agentsTable = true;

        const data = {
          companyId: this.company._id,
          zendeskUserIds:
            this.subscription.status === "active"
              ? this.subscription?.licenses?.users?.map(
                  (user) => user.zendeskUserId
                )
              : [],
        };
        const response = await UserService.GetAllUsers(data);

        if (!response.hasError) {
          this.agents = response.data;
          this.agents.forEach((a) => {
            this.$set(a, "languageField", _.cloneDeep(this.languageField));
            a.languageField.value = a.settings.defaultLanguage;
          });
        }
      }

      this.gettingAgents = false;
    },

    // Update agent
    async updateAgent(agent) {
      const payload = this.constructPayload(agent);
      await UserService.UpdateSettings(payload);
    },

    // Construct the payload
    constructPayload(agent) {
      const payload = {
        companyId: this.company._id,
        zendeskUserId: agent.zendeskUserId,
        settings: {
          defaultLanguage: agent.languageField.value,
        },
      };

      return payload;
    },

    // Redirect to subscriptions
    redirectSubscriptions() {
      this.$router.push({ path: `/apps/translations/subscription` });
    },

    // Event on scroll
    contentScroll() {
      const scrollTop = this.$refs.mainContent.scrollTop;

      // Check if header needs shadow
      if (scrollTop > 0) this.showOptions.headerShadow = true;
      else this.showOptions.headerShadow = false;
    },
  },
};
</script>
                
<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.main-content {
  display: flex;
  flex-direction: column;
}
</style>